import { render, staticRenderFns } from "./ExpandableInputBase.vue?vue&type=template&id=24856870&scoped=true&"
import script from "./ExpandableInputBase.vue?vue&type=script&lang=ts&"
export * from "./ExpandableInputBase.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableInputBase.vue?vue&type=style&index=0&id=24856870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24856870",
  null
  
)

export default component.exports